<template>
  <div class="batch-evolution-modern">
    <NavBar />
    <AuthBySessionExpired />

    <div class="batch-container">
      <div class="batch-header">
        <div class="header-content">
          <div class="title-section">
            <v-btn class="btn-return mb-3" v-on:click="$router.go(-1)">
              <i class="fas fa-arrow-left mr-2 text-twenty"></i> Voltar
            </v-btn>

            <h1 class="page-title">
              <i class="fas fa-clipboard-check title-icon"></i>
              Prescrições de checagem
            </h1>

            <p class="page-subtitle">
              Vizualiza as Prescrições de seus residentes
            </p>
          </div>
          <div class="text-right">
            <v-btn
              type="button"
              @click="
                $router.push({
                  name: 'config-resident-print-prescription-lote',
                })
              "
              small
              class="btn-modern btn-modern-info"
            >
              Configurar informações no imprimir
            </v-btn>
          </div>
        </div>
      </div>

      <div class="filters-section" v-if="$store.state.online">
        <div class="filters-card">
          <div class="filters-grid">
            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-filter filter-icon"></i>
                Gênero
              </label>

              <v-select
                dense
                :items="genders"
                v-model="gender"
                outlined
                hide-details
                class="modern-select"
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-search filter-icon"></i>
                Pesquisar
              </label>

              <v-text-field
                dense
                placeholder="Nome do residente"
                outlined
                hide-details
                v-model="name"
                class="modern-input"
                @input="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-chart-line filter-icon"></i>
                Dependência
              </label>

              <v-select
                dense
                :items="typesFilterByGrau"
                v-model="degree_of_dependence_id"
                outlined
                hide-details
                class="modern-select"
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-user filter-icon"></i>
                Usuário (Fez evolução)
              </label>

              <v-select
                dense
                :items="users"
                v-model="user_evolution_id"
                outlined
                hide-details
                class="modern-select"
                item-value="id"
                item-text="name"
                @change="getResidents"
              />
            </div>

            <div class="filter-group">
              <label class="filter-label">
                <i class="fas fa-bed filter-icon"></i>
                Ala/Setor
              </label>
              <v-select
                v-model="ward_or_sector"
                :items="beds"
                dense
                outlined
                hide-details
                class="modern-select"
                item-value="ward_or_sector"
                :item-text="
                  (value) => {
                    return value.ward_or_sector
                      ? `(ALA/Setor) ${value.ward_or_sector}`
                      : 'Não filtrar';
                  }
                "
                @change="getResidents"
              />
            </div>
          </div>
        </div>
      </div>

      <b-overlay :show="loading" opacity="0.99">
        <div class="content-card">
          <div class="select-all-section">
            <span class="select-all-label">
              <i class="fas fa-users mr-2"></i>
              Selecionar todos os residentes?
              <small>(Aceito apenas de 25 em 25 residentes por vez!)</small>
            </span>

            <b-form-group label="" class="mb-0">
              <b-form-radio-group
                v-model="selectAll"
                class="radio-group-modern"
              >
                <b-form-radio :value="true">SIM</b-form-radio>
                <b-form-radio :value="false">NÃO</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </div>

          <!-- residentes -->
          <div class="residents-grid">
            <div
              v-for="resident in residents"
              :key="resident.id"
              class="resident-checkbox-card"
              :class="{
                'resident-checkbox-card--selected': resident_ids.includes(
                  resident.id
                ),
              }"
            >
              <b-form-checkbox
                v-model="resident_ids"
                :value="resident.id"
                size="lg"
                class="checkbox-modern"
              >
                <div class="resident-checkbox-info">
                  <img
                    class="resident-thumb"
                    :src="resident.photo_url"
                    :alt="resident.name"
                  />
                  <span class="resident-checkbox-name">
                    {{ resident.name }}
                  </span>
                </div>
              </b-form-checkbox>
            </div>
          </div>

          <div class="filters-grid-2col mt-10">
            <div class="form-section">
              <label class="filter-label">
                <i class="fas fa-calendar-alt filter-icon"></i>
                Data
              </label>
              <input type="date" class="modern-form-input" v-model="date" />
            </div>

            <div class="form-section">
              <label class="filter-label">
                <i class="fas fa-calendar-check filter-icon"></i>
                Data final
              </label>
              <div class="date-input-group">
                <input
                  type="date"
                  class="modern-form-input"
                  v-model="end_date"
                />
                <v-btn class="btn-clear" @click="end_date = ''">LIMPAR</v-btn>
              </div>
            </div>

            <div class="form-section">
              <label class="filter-label">
                <i class="fas fa-sort filter-icon"></i>
                Ordernar por
              </label>
              <select v-model="order_by" class="modern-form-select">
                <option value="time">HORÁRIO</option>
                <option value="medicine_name">NOME DO MEDICAMENTO</option>
              </select>
            </div>

            <div v-if="!end_date" class="form-section">
              <label class="filter-label">
                <i class="fas fa-redo filter-icon"></i>
                Periodicidade
              </label>
              <select v-model="frequency" class="modern-form-select">
                <option value="SEMANAL">SEMANAL</option>
                <option value="QUINZENAL">QUINZENAL</option>
                <option value="MENSAL">MENSAL</option>
              </select>
            </div>
          </div>

          <div class="action-bar-inline">
            <v-btn
              v-if="permission('read', 'resident_medical_prescription')"
              @click="getPrescriptions()"
              class="btn-save"
            >
              <i class="fas fa-search mr-2"></i>
              Buscar
            </v-btn>
          </div>
        </div>

        <div v-if="prescriptionsResidents.length == 0 && warning">
          <div class="alert-badge alert-warning mx-auto">
            <span> Nenhuma prescrição encontrada! </span>
          </div>
        </div>

        <div v-for="(prescriptions, key) in prescriptionsResidents" :key="key">
          <div
            v-if="prescriptions.prescriptions.length > 0"
            class="content-card evolution-form-card"
          >
            <div class="resident-checkbox-info">
              <img
                class="resident-thumb"
                :src="prescriptions.resident.photo_url"
                :alt="prescriptions.resident.name"
              />
              <span class="resident-checkbox-name">
                {{ prescriptions.resident.name }}
              </span>
            </div>

            <div v-if="prescriptions.prescriptions.length > 0">
              <h6 class="prescription-validity-title mt-2">
                Prescrição Médica
                <strong>{{
                  prescriptions.group_prescription_medicine.type == "NORMAL"
                    ? "NORMAL"
                    : "LONGO PRAZO"
                }}</strong>
                - Validade
                <span class="color-blue">{{
                  formatDate(
                    prescriptions.group_prescription_medicine.start_date,
                    false
                  )
                }}</span>
                até
                <span class="color-blue">{{
                  formatDate(
                    prescriptions.group_prescription_medicine.end_date,
                    false
                  )
                }}</span>
              </h6>
            </div>

            <div class="table-responsive">
              <table
                v-if="prescriptions.prescriptions.length > 0"
                class="table table-bordered prescription-table"
              >
                <thead>
                  <th>MEDICAMENTO</th>
                  <th class="text-center">HORÁRIO</th>
                  <th
                    v-for="(item, key) in prescriptions.days"
                    :key="key"
                    v-show="item"
                    class="text-center"
                  >
                    {{ formatDateDayMonth(item) }}
                  </th>
                </thead>
                <tbody>
                  <tr
                    v-for="(prescription, key) in prescriptions.prescriptions"
                    :key="key"
                    v-show="prescription.items.length > 0"
                  >
                    <td style="width: auto; padding: 5px">
                      <h6 class="medicine-name mb-1">
                        {{ key + 1 }} -
                        {{ prescription.medicine.medicine_name }}
                      </h6>
                      <h6 class="medicine-legend mb-0">
                        {{ prescription.medicine.medicine_active_ingredient }}
                      </h6>
                      <h6 class="medicine-legend mb-0">
                        VIA:
                        {{ prescription.medicine.route_of_administration_name }}
                      </h6>
                      <h6
                        v-if="prescription.medicine.instruction"
                        class="medicine-legend mb-0"
                      >
                        {{ prescription.medicine.instruction }}
                      </h6>
                    </td>
                    <td style="width: auto">
                      <h6
                        class="medicine-time text-center"
                        v-if="!prescription.prescription_medicine_time.time"
                      >
                        EVENTUAL
                      </h6>
                      <h6
                        class="mb-0 medicine-time text-center"
                        style="width: auto"
                        v-if="prescription.prescription_medicine_time.time"
                      >
                        {{
                          String(
                            prescription.prescription_medicine_time.time
                          ).substr(0, 5)
                        }}
                      </h6>
                    </td>
                    <td
                      class="p-0"
                      v-for="item in prescription.items"
                      :key="item.id"
                      style="padding: 1px !important"
                    >
                      <div>
                        <Daily
                          v-if="
                            item.status != 'NAO_MOSTRAR' &&
                            item.item.frequency == 'DIARIO'
                          "
                          :item="item"
                        />
                        <Weekly
                          v-if="
                            item.status != 'NAO_MOSTRAR' &&
                            item.item.frequency == 'SEMANAL'
                          "
                          :item="item"
                        />
                        <Monthly
                          v-if="
                            item.status != 'NAO_MOSTRAR' &&
                            item.item.frequency == 'MENSAL'
                          "
                          :item="item"
                        />
                        <Yearly
                          v-if="
                            item.status != 'NAO_MOSTRAR' &&
                            item.item.frequency == 'ANUAL'
                          "
                          :item="item"
                        />
                        <Eventual
                          v-if="item.item.frequency == 'EVENTUAL'"
                          :item="item"
                        />
                      </div>
                      <div
                        class="text-center"
                        v-if="item.check_anticipated == 1"
                      >
                        <i class="fas fa-clock icon-check-anticipated"></i>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <ErrorsMessages :errors="errors" />

        <div v-if="prescriptionsResidents.length > 0" class="sticky-footer">
          <div class="sticky-footer-inner">
            <v-btn
              v-if="prescriptionsResidents.length > 0"
              @click="handlePrint"
              class="btn-print m-1"
            >
              <i class="fas fa-print mr-2 text-twenty"></i> IMPRIMIR</v-btn
            >
          </div>
        </div>

        <div
          v-if="prescriptionsResidents.length > 0"
          class="footer-spacer"
        ></div>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import Daily from "../templates/Resident/DailyRoutine/Prescription/View/Daily";

import Eventual from "../templates/Resident/DailyRoutine/Prescription/View/Eventual";

import Monthly from "../templates/Resident/DailyRoutine/Prescription/View/Monthly";

import Weekly from "../templates/Resident/DailyRoutine/Prescription/View/Weekly";

import Yearly from "../templates/Resident/DailyRoutine/Prescription/View/Yearly";

import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import ErrorsMessages from "../templates/Components/ErrorsMessages";

import api from "../services/api";

import permission from "../lib/permission";

import moment from "moment";

import { formatDate, formatDateDayMonth } from "../lib/format";

import { getRestHomeSelectedFinancialAccount } from "../lib/functions";

export default {
  name: "CheckingPrescriptions",

  components: {
    NavBar,
    AuthBySessionExpired,
    ErrorsMessages,
    Daily,
    Eventual,
    Monthly,
    Weekly,
    Yearly,
  },

  data() {
    return {
      ward_or_sector: "",

      user_evolution_id: null,

      selectAll: false,

      loading: false,

      warning: false,

      type: "",

      gender: "NONE",

      degree_of_dependence_id: "NONE",

      name: "",

      end_date: "",

      order_by: "time",

      frequency: "QUINZENAL",

      residents: [],

      resident_ids: [],

      errors: [],

      users: [],

      beds: [],

      prescriptionsResidents: [],

      genders: [
        { value: "NONE", text: "TODOS" },
        { value: "FEMININO", text: "FEMININO" },
        { value: "MASCULINO", text: "MASCULINO" },
      ],

      typesFilterByGrau: [
        { value: "NONE", text: "Não filtrar" },
        { value: "GRAU1", text: "GRAU 1" },
        { value: "GRAU2", text: "GRAU 2" },
        { value: "GRAU3", text: "GRAU 3" },
      ],

      date: moment().format("YYYY-MM-DD"),
    };
  },

  watch: {
    selectAll() {
      if (this.selectAll) {
        let ids = [];
        for (let resident of this.residents) {
          if (ids.length <= 24) {
            ids.push(resident.id);
          }
        }
        this.resident_ids = ids;
      } else {
        this.resident_ids = [];
      }
    },

    resident_ids(newVal, oldVal) {
      if (newVal.length > 25) {
        // remove o último selecionado
        this.resident_ids = oldVal;

        // opcional: feedback pro usuário
        this.$bvToast.toast("Você pode selecionar no máximo 25 residentes.", {
          title: "Limite atingido",
          variant: "warning",
          solid: true,
        });
      }
    },
  },

  created() {
    this.retrieve();
  },

  methods: {
    formatDate,
    formatDateDayMonth,
    getRestHomeSelectedFinancialAccount,
    permission,

    retrieve() {
      this.getUsers();
      this.getResidents();
      this.getAllBeds();
    },

    async getResidents() {
      try {
        this.loading = true;
        let {
          gender,
          name,
          degree_of_dependence_id,
          user_evolution_id,
          ward_or_sector,
        } = this;
        let params = {
          gender,
          name,
          degree_of_dependence_id,
          user_evolution_id,
          ward_or_sector,
        };

        const response = await api.get("/rest-home/residents/batch-evolution", {
          params,
        });

        const { error, errors, residents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          for (let resident of residents) {
            resident.checked = true;
          }
          this.resident_ids = [];
          this.residents = residents;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async getUsers() {
      try {
        let rest_home_id_selected_financial_account =
          this.getRestHomeSelectedFinancialAccount();

        let params = {
          rest_home_id_selected_financial_account,
        };

        const response = await api.get("/rest-home/users-actives", {
          params,
        });

        const { users } = response.data;

        this.users = [{ id: null, name: "TODOS" }, ...users];
      } catch (error) {
        console.log(error);
      }
    },

    async getAllBeds() {
      try {
        const response = await api.get("/rest-home/bed/ward");

        const { error, errors, beds } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.errors = [];
          this.beds = [{ id: null, ward_or_sector: "" }, ...beds];
        }
      } catch (error) {
        console.log(error);
      }
    },

    async getPrescriptions() {
      try {
        this.loading = true;

        this.warning = false;
        this.errors = [];
        this.prescriptionsResidents = [];

        const { resident_ids, date, end_date, order_by, frequency } = this;

        let params = {
          resident_ids,
          date,
          end_date,
          order_by,
          frequency,
          type: "NORMAL",
          filter: false,
        };

        const response = await api.get(
          "/rest-home/multiple-resident/medicine-check-print",
          {
            params,
          }
        );

        const { error, errors, prescriptionsResidents } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.prescriptionsResidents = prescriptionsResidents;
          this.warning = true;
        }

        setTimeout(() => (this.loading = false), 200);
      } catch (error) {
        console.log(error);
      }
    },

    handlePrint() {
      let { resident_ids, date, end_date, order_by, frequency } = this;

      if (!end_date) {
        end_date = false;
      }

      let params = {
        resident_ids: resident_ids.join(","),
        date,
        end_date,
        order_by,
        frequency,
      };

      let route = this.$router.resolve({
        name: "medicine_check_multiple_resident_print",
        params,
      });

      window.open(route.href, "_blank");
    },
  },
};
</script>

<style scoped>
.batch-evolution-modern {
  min-height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.batch-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px 100px;
}

.batch-header {
  padding: 24px 0;
  background: white;
  border-radius: 0 0 24px 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin-bottom: 32px;
}

.header-content {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
}

.page-title {
  font-size: 32px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  display: flex;
  align-items: center;
}

.title-icon {
  color: #0f65b0;
  margin-right: 12px;
}

.page-subtitle {
  color: #64748b;
  margin: 4px 0 0 0;
  font-size: 16px;
}

.filters-section {
  margin-bottom: 24px;
}

.filters-card {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.filters-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.filter-label {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 2px;
}

.filter-icon {
  color: #6b7280;
  font-size: 13px;
}

.content-card {
  background: white;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(15, 23, 42, 0.08);
  border: 1px solid #e5e7eb;
  padding: 28px;
  margin-bottom: 20px;
}

.select-all-section {
  display: flex;
  align-items: center;
  gap: 16px;
  padding-bottom: 20px;
  margin-bottom: 24px;
  border-bottom: 1px solid #e5e7eb;
  flex-wrap: wrap;
}

.select-all-label {
  font-size: 15px;
  font-weight: 700;
  color: #1e293b;
  display: flex;
  align-items: center;
}

.radio-group-modern >>> .custom-radio .custom-control-label {
  font-weight: 600;
  color: #374151;
  cursor: pointer;
}

.residents-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 6px;
}

.resident-checkbox-card {
  background: #f8fafc;
  border: 1.5px solid #e5e7eb;
  border-radius: 8px;
  padding: 7px 10px;
  transition: all 0.15s ease;
  cursor: pointer;
}

.resident-checkbox-card:hover {
  border-color: #0f65b0;
  background: #eff6ff;
  box-shadow: 0 1px 6px rgba(15, 101, 176, 0.1);
}

.resident-checkbox-card--selected {
  border-color: #0f65b0;
  background: linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%);
  box-shadow: 0 1px 6px rgba(15, 101, 176, 0.15);
}

.resident-checkbox-info {
  display: flex;
  align-items: center;
  gap: 7px;
  margin-left: 2px;
}

.resident-thumb {
  width: 24px;
  height: 24px;
  object-fit: cover;
  border-radius: 50%;
  border: 1.5px solid #e5e7eb;
  flex-shrink: 0;
}

.resident-checkbox-name {
  font-size: 12px;
  font-weight: 600;
  color: #1e293b;
  line-height: 1.2;
  overflow: hidden;
  text-overflow: ellipsis;
}

.evolution-form-card {
  display: flex;
  flex-direction: column;
  gap: 28px;
}

.form-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.form-section-header {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e5e7eb;
}

.form-section-icon {
  color: #0f65b0;
  font-size: 14px;
}

.form-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.modern-form-input {
  width: 100%;
  padding: 11px 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  background: #f8fafc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modern-form-input:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.date-input-group {
  display: flex;
  gap: 10px;
  align-items: center;
}

.date-input-group .modern-form-input {
  flex: 1;
}

.btn-clear {
  background: #f1f5f9 !important;
  color: #475569 !important;
  border: 1.5px solid #e5e7eb !important;
  border-radius: 8px !important;
  font-size: 12px !important;
  font-weight: 600 !important;
  padding: 8px 14px !important;
  text-transform: none !important;
  transition: all 0.15s ease !important;
  white-space: nowrap;
}

.btn-clear:hover {
  background: #e2e8f0 !important;
  border-color: #cbd5e1 !important;
}

.modern-form-select {
  width: 100%;
  padding: 11px 14px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  background: #f8fafc;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  appearance: none;
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.modern-form-select:focus {
  border-color: #0f65b0;
  box-shadow: 0 0 0 3px rgba(15, 101, 176, 0.1);
  outline: none;
}

.action-bar-inline {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.btn-save {
  background: linear-gradient(135deg, #0f65b0 0%, #1d7fd4 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 24px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(15, 101, 176, 0.3) !important;
  transition: all 0.2s ease !important;
}

.btn-save:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 18px rgba(15, 101, 176, 0.4) !important;
}

.btn-print {
  background: linear-gradient(135deg, #475569 0%, #334155 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 20px !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  text-transform: none !important;
  box-shadow: 0 4px 14px rgba(51, 65, 85, 0.25) !important;
  transition: all 0.2s ease !important;
}

.btn-print:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 18px rgba(51, 65, 85, 0.35) !important;
}

.alert-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 10px;
  padding: 12px 20px;
  font-size: 13px;
  font-weight: 600;
  width: fit-content;
  max-width: 100%;
  margin-bottom: 16px;
}

.alert-warning {
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1.5px solid #f59e0b;
  color: #92400e;
  box-shadow: 0 2px 8px rgba(245, 158, 11, 0.12);
}

.prescription-validity-title {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.color-blue {
  color: #0f65b0;
  font-weight: 700;
}

.prescription-table {
  border-radius: 8px;
  overflow: hidden;
  font-size: 13px;
}

.prescription-table thead th {
  background: #f1f5f9;
  color: #374151;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  padding: 10px 8px;
  border-color: #e5e7eb;
}

.prescription-table tbody tr:hover {
  background: #f8fafc;
}

.prescription-table tbody td {
  border-color: #e5e7eb;
  vertical-align: middle;
}

.medicine-name {
  font-size: 13px;
  font-weight: 700;
  color: #1e293b;
}

.medicine-legend {
  font-size: 11px;
  font-weight: 500;
  color: #64748b;
}

.medicine-time {
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin: 0;
}

.icon-check-anticipated {
  color: #f59e0b;
  font-size: 13px;
}

.footer-spacer {
  height: 20px;
}

.batch-warning-badge {
  display: flex;
  align-items: center;
  gap: 7px;
  background: linear-gradient(135deg, #fffbeb 0%, #fef3c7 100%);
  border: 1.5px solid #f59e0b;
  border-radius: 8px;
  padding: 8px 16px;
  color: #92400e;
  font-size: 12px;
  font-weight: 600;
  width: fit-content;
  max-width: 100%;
  box-shadow: 0 2px 6px rgba(245, 158, 11, 0.12);
}

.batch-warning-badge i {
  color: #d97706;
  font-size: 12px;
  flex-shrink: 0;
}

.batch-warning-badge span {
  line-height: 1.4;
}

.batch-warning-group {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
}

.batch-warning-badge--purple {
  background: linear-gradient(135deg, #faf5ff 0%, #ede9fe 100%);
  border-color: #a78bfa;
  color: #4c1d95;
  box-shadow: 0 2px 6px rgba(167, 139, 250, 0.12);
}

.batch-warning-badge--purple i {
  color: #7c3aed;
}

@media (max-width: 768px) {
  .batch-container {
    padding: 0 16px 100px;
  }

  .batch-header {
    padding: 16px 0;
    margin-bottom: 20px;
  }

  .page-title {
    font-size: 24px;
  }

  .residents-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  }

  .filters-grid {
    grid-template-columns: 1fr;
  }

  .select-all-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .action-bar-inline {
    justify-content: stretch;
  }

  .date-input-group {
    flex-direction: column;
    align-items: stretch;
  }

  .btn-clear {
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .residents-grid {
    grid-template-columns: 1fr 1fr;
  }

  .action-bar-inline {
    flex-direction: column;
  }

  .btn-save {
    width: 100% !important;
    justify-content: center !important;
  }
}

.sticky-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  background: white;
  border-top: 1px solid #e5e7eb;
  box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.08);
  padding: 12px 24px;
}

.sticky-footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.filters-grid-2col {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  margin-bottom: 20px;
}

@media (max-width: 480px) {
  .filters-grid-2col {
    grid-template-columns: 1fr;
  }
}
</style>